import {
  MagnifyingGlassIcon,
  CheckCircleIcon,
} from "@heroicons/react/20/solid";
import { useState, useEffect } from "react";
import { RadioGroup } from "@headlessui/react";
import { classNames, extractDataOO } from "../../utils/helperFuctions";
import ViewCard from "./ViewCard";
import { PropagateLoader } from "react-spinners";
import { config } from "../../utils/config";
import axios from "axios";
import { getCookie, setCookie } from "../../utils/cookieHandler";

// Define a cancel token source
let cancelTokenSource;

export default function SelectionList({
  data,
  searchable,
  searchPlaceholder,
  propertyName,
  url,
  handleChange,
  toShow,
  statusColors,
  filters,
  dataParam,
  currentFields,
}) {
  const [selectedItem, setSelectedItem] = useState();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("No Data Available");

  const [searchvalue, setSearchValue] = useState("");

  const getData = () => {
    setLoading(true);

    // Cancel the previous request, if any
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    // Create a new cancel token source
    cancelTokenSource = axios.CancelToken.source();

    // Use the cancel token in the Axios request
    const axiosConfig = {
      cancelToken: cancelTokenSource.token,
      headers: { Authorization: `Bearer ${getCookie("_AT")}` },
    };

    if (searchable && searchvalue) {
      setShowItems([]);
      try {
        axios
          .get(
            `${config.apiUrl}/api/${url}?pagination=false&search=${searchvalue}&${filters}`,
            axiosConfig
          )
          .then((resp) => {
            if (resp.headers?.authorization) {
              if (`Bearer ${getCookie("_AT")}` !== resp.headers.authorization) {
                setCookie("_AT", resp.headers.authorization.split(" ")[1]);
              }
            }
            // console.log(respData, "respData");
            // console.log(extractDataOO(respData, toShow), "extract");
            // copy if from down below
            if (
              resp &&
              resp.data &&
              (Array.isArray(resp.data) ||
                (dataParam != null && Array.isArray(resp.data[dataParam]))) &&
              (resp.data.length > 0 || resp.data[dataParam].length > 0)
            ) {
              let respData =
                dataParam != null ? resp.data[dataParam] : resp.data;

              setShowItems(
                toShow ? extractDataOO(respData, toShow) : resp.data
              );
            }

            setLoading(false);
          })
          .catch((e) => {
            console.log(e.message);
          });
      } catch (error) {
        //console.log('Previous request canceled');
        // Handle the error here if needed
        if (axios.isCancel(error)) {
          //console.log('Previous request canceled');
        } else {
          // Handle other errors
          setLoading(false);
          console.error(`Error fetching data for ${propertyName}:`, error);
        }
      }
      //} //else if (searchable && !searchvalue) {
      //setMessage(searchPlaceholder ?? 'Search for your data');
      //setShowItems([]);
      //setLoading(false);
    } else {
      try {
        //console.log('url: ',`${config.apiUrl}/api/${url}?${filters}`)
        axios
          .get(
            `${config.apiUrl}/api/${url}?pagination=false&${filters}`,
            axiosConfig
          )
          .then((resp) => {
            if (resp.headers?.authorization) {
              if (`Bearer ${getCookie("_AT")}` !== resp.headers.authorization) {
                setCookie("_AT", resp.headers.authorization.split(" ")[1]);
              }
            }
            if (
              resp &&
              resp.data &&
              (Array.isArray(resp.data) ||
                (dataParam != null && Array.isArray(resp.data[dataParam]))) &&
              (resp.data.length > 0 || resp.data[dataParam].length > 0)
            ) {
              //console.log('response SelectionList: ', toShow ? extractDataOO(resp.data, toShow) : resp.data);
              let respData =
                dataParam != null ? resp.data[dataParam] : resp.data;
              console.log(extractDataOO(respData, toShow), toShow, respData);

              setShowItems(
                toShow ? extractDataOO(respData, toShow) : resp.data
              );
            }

            setLoading(false);
          })
          .catch((e) => {
            console.log(e.message);
          });
      } catch (error) {
        //console.log('Previous request canceled');
        // Handle the error here if needed
        if (axios.isCancel(error)) {
          //console.log('Previous request canceled');
        } else {
          // Handle other errors
          setLoading(false);
          console.error(`Error fetching data for ${propertyName}:`, error);
        }
      }
    }

    return [];
  };

  const [showItems, setShowItems] = useState();

  useEffect(() => {
    if (!showItems) {
      const _d = data ? (toShow ? extractDataOO(data, toShow) : data) : null;
      if (_d) {
        setShowItems(_d);
      } else {
        getData();
      }
    }
  }, []);

  useEffect(() => {
    getData();
  }, [searchvalue]);

  const searchChanged = (e) => {
    setSearchValue(e.target.value);
  };
  const selectedChanged = (data) => {
    setSelectedItem(data);
    handleChange(data);
  };
  return (
    <div className="border rounded-md m-2">
      {searchable && (
        <div className="relative divide-y divide-y-reverse mb-4">
          <MagnifyingGlassIcon
            className="pointer-events-none absolute left-4 top-3.5 h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
          <input
            className="h-12 w-full border-0 bg-transparent pl-11 pr-4 text-gray-900 placeholder:text-gray-400 focus:ring-0 focus:outline-1 focus:outline-violet-700 sm:text-sm"
            placeholder="Search..."
            onChange={searchChanged}
            value={searchvalue}
          />
        </div>
      )}

      <RadioGroup value={selectedItem} onChange={selectedChanged}>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 m-5">
          {showItems &&
            showItems.map((item) => (
              <RadioGroup.Option
                key={item.id}
                value={item}
                className={({ active }) =>
                  classNames(
                    active ? "border-violet-600 ring-2 ring-violet-600" : "",
                    "col-span-1 flex flex-col rounded-lg bg-white text-center  relative"
                  )
                }
              >
                {({ checked, active }) => (
                  <>
                    <CheckCircleIcon
                      className={classNames(
                        !checked ? "invisible" : "",
                        "h-5 w-5 text-violet-600 absolute"
                      )}
                      aria-hidden="true"
                    />
                    <ViewCard
                      currentFields={currentFields}
                      data={item}
                      statusColors={statusColors}
                    />

                    <span
                      className={classNames(
                        active ? "border" : "border-2",
                        checked ? "border-violet-600" : "border-transparent",
                        "pointer-events-none absolute -inset-px rounded-lg"
                      )}
                      aria-hidden="true"
                    />
                  </>
                )}
              </RadioGroup.Option>
            ))}
          {(!showItems ||
            (Array.isArray(showItems) && showItems.length === 0)) && (
            <p className="col-span-full">
              {loading ? <PropagateLoader color="#5729BC" /> : message}
            </p>
          )}
        </div>
      </RadioGroup>
    </div>
  );
}
